/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_DescriptionInputs */

const vi_media_field_description = /** @type {(inputs: Media_Field_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả chi tiết`)
};

/**

* @param {Media_Field_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_description = /** @type {((inputs?: Media_Field_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_description(inputs)
});